import React from 'react';
import { Check, Clock, X, Settings } from 'lucide-react';

const Home = () => {
  return (
    <div>
      <h1 className="page-title" style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '28px', fontWeight: 700, color: '#000000', marginBottom: '24px', textTransform: 'none' }}>
        Dashboard
      </h1>
      
      {/* Stats Cards */}
      <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '24px' }}>
        <div className="stat-card" style={{ background: '#FFFFFF', borderRadius: '12px', padding: '20px', border: '1px solid #A9A9A9', transition: 'all 0.3s ease' }}>
          <h3 style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '16px', fontWeight: 700, color: '#000000', marginBottom: '16px' }}>
            Calls
          </h3>
          <div style={{ fontSize: '13px', color: '#A9A9A9', marginBottom: '6px', fontFamily: "'Canva Sans', sans-serif" }}>Voice – Outbound</div>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0', fontSize: '14px', color: '#10b981' }}>
              <Check style={{ width: '16px', height: '16px' }} />
              <strong>152</strong> Completed
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0', fontSize: '14px', color: '#6b7280' }}>
              <Clock style={{ width: '16px', height: '16px' }} />
              <strong>23</strong> Incomplete
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0', fontSize: '14px', color: '#ef4444' }}>
              <X style={{ width: '16px', height: '16px' }} />
              <strong>12</strong> Missed
            </li>
          </ul>
        </div>

        <div className="stat-card" style={{ background: '#FFFFFF', borderRadius: '12px', padding: '20px', border: '1px solid #A9A9A9', transition: 'all 0.3s ease' }}>
          <h3 style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '16px', fontWeight: 700, color: '#000000', marginBottom: '16px' }}>
            Actions
          </h3>
          <div style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '36px', fontWeight: 700, color: '#000000', marginBottom: '12px', lineHeight: 1 }}>
            4
          </div>
          <div style={{ fontSize: '13px', color: '#A9A9A9', marginBottom: '6px', fontFamily: "'Canva Sans', sans-serif" }}>Cologuard Orders</div>
        </div>

        <div className="stat-card" style={{ background: '#FFFFFF', borderRadius: '12px', padding: '20px', border: '1px solid #A9A9A9', transition: 'all 0.3s ease' }}>
          <h3 style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '16px', fontWeight: 700, color: '#000000', marginBottom: '16px' }}>
            Attention
          </h3>
          <div style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '36px', fontWeight: 700, color: '#000000', marginBottom: '12px', lineHeight: 1 }}>
            3
          </div>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ padding: '6px 0', fontSize: '14px', color: '#000000', fontFamily: "'Canva Sans', sans-serif" }}>• Results Review</li>
            <li style={{ padding: '6px 0', fontSize: '14px', color: '#000000', fontFamily: "'Canva Sans', sans-serif" }}>• Family History</li>
            <li style={{ padding: '6px 0', fontSize: '14px', color: '#000000', fontFamily: "'Canva Sans', sans-serif" }}>• Address Change</li>
          </ul>
        </div>
      </div>

      {/* Charts Section */}
      <div className="charts-section" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        {/* Call Volume Chart */}
        <div className="chart-card" style={{ background: '#FFFFFF', borderRadius: '12px', padding: '20px 24px', border: '1px solid #A9A9A9' }}>
          <div style={{ marginBottom: '16px' }}>
            <h2 style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '16px', fontWeight: 700, color: '#000000', marginBottom: '4px' }}>
              Call Volume (Last Week)
            </h2>
            <p style={{ fontSize: '12px', color: '#A9A9A9', fontFamily: "'Canva Sans', sans-serif" }}>Daily outbound call metrics and completion rates</p>
          </div>

          <div className="line-chart" style={{ height: '180px', position: 'relative', marginTop: '12px' }}>
            <svg viewBox="0 0 700 180" preserveAspectRatio="none" style={{ position: 'absolute', width: '100%', height: '100%' }}>
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#459EA3', stopOpacity: 0.3 }} />
                  <stop offset="100%" style={{ stopColor: '#459EA3', stopOpacity: 0 }} />
                </linearGradient>
              </defs>
              
              {/* Area */}
              <path 
                d="M 0,170 L 0,150 L 100,150 L 200,135 L 300,128 L 400,142 L 500,132 L 600,120 L 700,110 L 700,170 Z"
                fill="url(#gradient)"
                opacity={0.15}
              />
              
              {/* Line */}
              <path 
                d="M 0,150 L 100,150 L 200,135 L 300,128 L 400,142 L 500,132 L 600,120 L 700,110"
                fill="none"
                stroke="#459EA3"
                strokeWidth="3"
                style={{ filter: 'drop-shadow(0 2px 4px rgba(69, 158, 163, 0.2))' }}
              />
              
              {/* Points */}
              {[0, 100, 200, 300, 400, 500, 600, 700].map((x, i) => {
                const yValues = [150, 150, 135, 128, 142, 132, 120, 110];
                return (
                  <circle 
                    key={i}
                    cx={x} 
                    cy={yValues[i]} 
                    r="4"
                    fill="#FFFFFF"
                    stroke="#459EA3"
                    strokeWidth="3"
                    style={{ transition: 'all 0.2s ease' }}
                  />
                );
              })}
            </svg>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px', paddingLeft: '20px', paddingRight: '20px' }}>
            {['Qtr 1', 'Qtr 2', 'Qtr 3', 'Qtr 4', 'Qtr 5', 'Qtr 6', 'Qtr 7'].map((label, i) => (
              <span key={i} style={{ fontSize: '11px', color: '#A9A9A9', fontFamily: "'Canva Sans', sans-serif" }}>{label}</span>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '20px', marginTop: '12px', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontFamily: "'Canva Sans', sans-serif" }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#459EA3' }}></span>
              <span>Successful</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontFamily: "'Canva Sans', sans-serif" }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#fca5a5' }}></span>
              <span>Declined</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontFamily: "'Canva Sans', sans-serif" }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#A9A9A9' }}></span>
              <span>Other</span>
            </div>
          </div>
        </div>

        {/* Demographics */}
        <div className="chart-card" style={{ background: '#FFFFFF', borderRadius: '12px', padding: '20px 24px', border: '1px solid #A9A9A9' }}>
          <div style={{ marginBottom: '16px' }}>
            <h2 style={{ fontFamily: "'Canva Sans', sans-serif", fontSize: '16px', fontWeight: 700, color: '#000000', marginBottom: '4px' }}>
              Total Calls by Demographics
            </h2>
            <p style={{ fontSize: '12px', color: '#A9A9A9', fontFamily: "'Canva Sans', sans-serif" }}>Call distribution across patient demographics</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px', marginTop: '20px' }}>
            {[
              { title: 'By Age', segments: [{ color: '#459EA3', dash: 180 }, { color: '#fca5a5', dash: 56, offset: -180 }, { color: '#A9A9A9', dash: 44, offset: -236 }] },
              { title: 'By Gender', segments: [{ color: '#459EA3', dash: 170 }, { color: '#fca5a5', dash: 84, offset: -170 }, { color: '#A9A9A9', dash: 26, offset: -254 }] },
              { title: 'By Language', segments: [{ color: '#459EA3', dash: 196 }, { color: '#A9A9A9', dash: 56, offset: -196 }, { color: '#A9A9A9', dash: 28, offset: -252 }] },
            ].map((demo, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#000000', marginBottom: '12px', fontFamily: "'Canva Sans', sans-serif" }}>
                  {demo.title}
                </h3>
                <div style={{ width: '120px', height: '120px', margin: '0 auto 10px', position: 'relative' }}>
                  <svg viewBox="0 0 120 120" style={{ transform: 'rotate(-90deg)' }}>
                    {demo.segments.map((seg, j) => (
                      <circle
                        key={j}
                        cx="60"
                        cy="60"
                        r="45"
                        fill="none"
                        stroke={seg.color}
                        strokeWidth="22"
                        strokeDasharray={`${seg.dash} 280`}
                        strokeDashoffset={seg.offset || 0}
                        style={{ transition: 'all 0.3s ease' }}
                      />
                    ))}
                  </svg>
                </div>
              </div>
            ))}
          </div>
          
          <div style={{ display: 'flex', gap: '20px', marginTop: '12px', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontFamily: "'Canva Sans', sans-serif" }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#459EA3' }}></span>
              <span>Successful</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontFamily: "'Canva Sans', sans-serif" }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#fca5a5' }}></span>
              <span>Declined</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontFamily: "'Canva Sans', sans-serif" }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#A9A9A9' }}></span>
              <span>Other</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
